export const UI_SELECTOR = '[data-rchat-ui]';
export const UI_CLASS = 'rchat-ui';
export const ADMIN_SELECTOR = '[data-rchat-admin]';
export const ADMIN_CLASS = 'rchat-admin';
export const EMBED_NAME = 'data-rchat-embed';
export const EMBED_SELECTOR = '[' + EMBED_NAME + ']';
export const EMBED_CLASS = 'rchat-embeds';

export const SETTINGS_ENDPOINT = '/settings';
export const SETTINGS_GUEST_PREFIX_ENDPOINT = `${SETTINGS_ENDPOINT}/guestPrefix`
export const SETTINGS_GUEST_NAMES_ENDPOINT = `${SETTINGS_ENDPOINT}/guestNames`

export const USERS_ENDPOINT = '/users';
export const CONNECTED_ENDPOINT = '/.info/connected';
export const PRESENCE_ENDPOINT = '/presence';
export const GUESTS_ENDPOINT = '/guests';

export const MESSAGES_ENDPOINT = '/messages'

export const CONVERSATIONS_PRIVATE_ENDPOINT = '/conversations/private';
export const CONVERSATIONS_PRIVATE_REFS_ENDPOINT = '/conversations/_refs/private'
export const CONVERSATION_STACKS_ENDPOINT = '/conversations/_stacks'
export const CONVERSATION_MESSAGE_COUNTS_ENDPOINT = '/conversations/_counts'
export const CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT = '/conversations/_refs/_counts'

export const NOTIFICATIONS_ENDPOINT = '/notifications';
export const MESSAGE_NOTIFICATIONS_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/messages';
export const REPORT_NOTIFICATIONS_ENDPOINT = NOTIFICATIONS_ENDPOINT + '/reports';

export const SETTINGS_SEGMENTS_ENDPOINT = SETTINGS_ENDPOINT + '/segments';

export const SESSIONS_ENDPOINT = '/sessions'
export const EXPERT_SESSIONS_ENDPOINT = SESSIONS_ENDPOINT + '/experts'
export const EXPERT_SESSION_ACTIVITIES_ENDPOINT = SESSIONS_ENDPOINT + '/_activities/experts'
export const EXPERT_SESSION_COUNTS_ENDPOINT = SESSIONS_ENDPOINT + '/_counts'
export const EXPERT_SESSIONS_REF_ENDPOINT = SESSIONS_ENDPOINT + '/_refs/experts'
export const EXPERT_SESSION_REQUESTS_ENDPOINT = SESSIONS_ENDPOINT + '/_requests/experts'
export const EXPERT_SESSION_CLAIMS_ENDPOINT = SESSIONS_ENDPOINT + '/_claims/experts'

export const PAYOUTS_ENDPOINT = '/payouts'
export const STRIPE_PAYOUTS_ENDPOINT = PAYOUTS_ENDPOINT + '/stripe'
export const STRIPE_PAYOUT_REQUESTS_ENDPOINT = PAYOUTS_ENDPOINT + '/_requests/stripe'

export const CUSTOMERS_ENDPOINT = '/customers'
export const STRIPE_CUSTOMERS_ENDPOINT = CUSTOMERS_ENDPOINT + '/stripe'

export const REVIEWS_ENDPOINT = '/reviews'
export const EXPERT_REVIEWS_ENDPOINT = REVIEWS_ENDPOINT + '/experts'
export const EXPERT_REVIEW_COUNTS_ENDPOINT = REVIEWS_ENDPOINT + '/_counts/experts'

export const SCHEDULES_ENDPOINT = '/schedules'

export const VIEW_AGGREGATIONS_ENDPOINT = '/viewAggregations'
export const CHAT_LIST_VIEW_ENDPOINT = VIEW_AGGREGATIONS_ENDPOINT + '/chatList'
export const USERS_VIEW_ENDPOINT = VIEW_AGGREGATIONS_ENDPOINT + '/users'

export const GROUP_CHAT_ENDPOINT = '/groups'
export const GROUP_CHAT_SCOPES_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_scopes'
export const GROUP_CHAT_ORDERS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_orders'
export const GROUP_CHAT_BOOKMARKS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_bookmarks'
export const GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT = GROUP_CHAT_ENDPOINT + '/_subscriptions'
export const GROUP_CHAT_SUBSCRIPTION_USERS_ENDPOINT = GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT + '/users'
export const GROUP_CHAT_SUBSCRIPTION_GROUPS_ENDPOINT = GROUP_CHAT_SUBSCRIPTIONS_ENDPOINT + '/groups'

export const ADVERTISEMENTS_ENDPOINT = '/advertisements'
export const FIXED_SLOT_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/fixedSlot'
export const CHAT_BOT_SLOT_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/chatBotSlot'
export const GENERAL_SETTINGS_ADVERTISEMENTS_ENDPOINT = ADVERTISEMENTS_ENDPOINT + '/settings'

export const SERVICES_ENDPOINT = '/services'
export const SEARCH_SERVICE_ENDPOINT = SERVICES_ENDPOINT + '/search'
export const SEARCH_SERVICE_TRANSACTIONS_ENDPOINT = SEARCH_SERVICE_ENDPOINT + '/transactions'
export const SEARCH_SERVICE_TRANSACTIONS_REQUEST_ENDPOINT = SEARCH_SERVICE_TRANSACTIONS_ENDPOINT + '/requests'
export const SEARCH_SERVICE_TRANSACTIONS_RESPONSE_ENDPOINT = SEARCH_SERVICE_TRANSACTIONS_ENDPOINT + '/responses'

export function EXPERT_SESSIONS_REF_USER_ENDPOINT (uid, otherUid) {
  return `${EXPERT_SESSIONS_REF_ENDPOINT}/${uid}/${otherUid}`
}

export function USER_CONVERSATIONS_PRIVATE_ENDPOINT (userId, otherUserId) {
  return CONVERSATIONS_PRIVATE_REFS_ENDPOINT + '/' + userId + '/' + otherUserId;
}

export function CONVERSATIONS_PRIVATE_MESSAGES_ENDPOINT (conversationId) {
  return CONVERSATIONS_PRIVATE_ENDPOINT + '/' + conversationId + '/messages';
}

export function USER_MESSAGE_NOTIFICATIONS_ENDPOINT (uid) {
  return MESSAGE_NOTIFICATIONS_ENDPOINT + '/' + uid;
}

export function USER_IGNORED_USER_ENDPOINT (cUid, uid) {
  return `${USERS_ENDPOINT}/${cUid}/ignored/${uid}`;
}

export function USER_IGNORING_USER_ENDPOINT (uid, cUid) {
  return `${USERS_ENDPOINT}/${uid}/ignoring/${cUid}`;
}

export function USER_REPORTS_ENDPOINT (uid) {
  return `${USERS_ENDPOINT}/${uid}/reports`;
}

export const VIEWPORT_MAX_WIDTH_PHONE = 480;

export const VIEWPORT_TYPES = {
  PHONE: 'phone',
  DESKTOP: 'desktop'
}

export const PRESENCE = {
  OFFLINE: 0,
  AWAY: 1,
  BUSY: 2,
  ONLINE: 3
};

export const PRESENCE_COLORS = {
  0: '#9E9E9E',
  1: '#FFCA28',
  2: '#E62A10',
  3: '#2BAF2B'
};

export const PRESENCE_LABELS = {
  // 0: 'Offline', // TODO: reenable this after making 'seen offline'
  1: 'Away',
  2: 'Busy',
  3: 'Online'
}

export const PRESENCE_CRUD_LABELS = {
  0: 'Offline',
  1: 'Away',
  2: 'Busy',
  3: 'Online'
}

export const ROLES = {
  GUEST: 0,
  USER: 1,
  PREMIUM: 2,
  EXPERT: 3,
  AUTHOR: 4,
  ADMIN: 5
}

export const ROLE_COLORS = {
  0: '#BDBDBD',
  1: '#4FC3F7',
  2: '#EF6C00',
  3: '#D84315',
  4: '#056F00',
  5: '#C52100'
}

export const ROLE_LABELS = {
  0: 'Guest',
  1: 'User',
  2: 'Premium',
  3: 'Expert',
  4: 'Author',
  5: 'Admin'
}

export const BAN_VALUES = {
  NOT_BANNED: 0,
  BANNED: 1
}

export const BAN_LABELS = {
  0: 'Not Banned',
  1: 'Banned'
}

export const CHAT_STATUS = {
  ON: 1,
  OFF: 0
}

export const CHAT_SETTINGS = {
  chatStatus: CHAT_STATUS.OFF,
  idleStartMinutes: 3,
  inactivityStartSeconds: 15,
  stopWords: '',
  guestPrefix: 'Guest',
  guestNames: '',
  helpPageUrl: 'https://www.rotoballer.com',
  colors: {
    main: {
      primary: '#0C2B44'
    },
    chatList: {
      background: '#FFFFFF',
      headerBackground: '#0C2B44',
      currentUserBarBackground: '#0E3351',
      itemHoverColor: '#F2F2F2',
      username: '#212121'
    },
    conversation: {
      background: '#F5F5F5',
      headerBackground: '#0C2B44',
      secondaryHeaderBackground: '#0E3351',
      messageColor: '#212121',
      receiverBubbleBackground: '#E0E0E0',
      senderBubbleBackground: '#FFFFFF'
    }
  },
  segments: {
    recents: { order: 0, title: 'RECENTS', numberOfUsers: 10, dayTimeout: 5 },
    groups: {order: 1, title: 'GROUP CHATS'},
    admins:  { order: 2, title: 'ADMINS', numberOfUsers: 10},
    writers: { order: 3, title: 'WRITERS', numberOfUsers: 10},
    experts: { order: 4, title: 'EXPERTS', numberOfUsers: 10},
    users:   { order: 5, title: 'USERS', numberOfUsers: 10}
  },
  sessionPaymentLengths: [
    {label: '10 minutes', value: 10},
    {label: '15 minutes', value: 15},
    {label: '30 minutes', value: 30},
    {label: '1 hour', value: 60},
    {label: '2 hours', value: 120}
  ],
  sessionRequestTimeout: 60
}

export const PAY_AS_YOU_GO_VALUE = 999999

export const CONVERSATION_TYPES = {
  GUEST: 0,
  NORMAL: 1,
  EXPERT: 2,
  GROUP: 3,
  MIXED: 999
}

export const SESSION_REQUEST_STATUSES = {
  DISMISSED: -1,
  INITIAL: 0,
  REQUESTED: 1,
  ACCEPTED: 2,
  TIMEDOUT: 999
}

export const SESSION_STATUSES = {
  CANCELLED: -2,
  REQUESTED_CANCEL: -1,
  INITIATED: 0,
  BOOKED: 1,
  PAID: 2,
  ACTIVE: 3,
  PAUSED: 4,
  COMPLETED: 5
}

export const SESSION_TYPES = {
  IMMEDIATE: 1,
  BOOKED: 2
}

export const SESSION_CANCELLATION_TYPES = {
  EXPERT_CANCELLED: 1,
  USER_CANCELLED: 2,
  EXPERT_NOT_SHOWED_UP: 3,
  USER_NOT_SHOWED_UP: 4,
  NOBODY_SHOWED_UP: 5
}

export const SESSION_CANCELLATION_TYPE_REASONS = {
  1: 'Expert cancelled the session',
  2: 'User cancelled the session',
  3: 'Expert didn\'t show up',
  4: 'User didn\'t show up',
  5: 'Both sides didn\'t show up'
}

export const SESSION_STATUS_LABELS = {
  '-2': 'Canceled',
  '-1': 'Requested Cancel',
  0: 'Initiated',
  1: 'Booked',
  2: 'Paid',
  3: 'Active',
  4: 'Paused',
  5: 'Completed'
}

export const SESSION_PRESENCES = {
  DISCONNECTED: -1,
  INITIAL: 0,
  ACTIVE: 1
}

export const MESSAGE_TYPES = {
  NORMAL: 1,
  EXPERT: 2,
  GROUP: 3,
  MODERATED_GROUP: 4,
  ADVERTISEMENT_BOT: 10
}

export const MESSAGE_APPROVAL_STATUSES = {
  DECLINED: -1,
  INITIAL: 0,
  APPROVED: 1
}

export const PAYOUT_REQUEST_STATUSES = {
  ERROR: -2,
  CANCELLED: -1,
  PENDING: 0,
  REQUESTED: 1,
  BOOKED: 2,
  SUCCESS: 3
}

export const PAYOUT_STATUSES = {
  REFUNDED: -1,
  PAID: 1
}

export const PAYOUT_STATUS_LABELS = {
  '-1': 'Refunded',
  1: 'Paid'
}

export const SCHEDULE_ENTRIES = {
  AVAILABLE_TIME: 1,
  BOOKED: 2
}

export const SCHEDULE_SLOT_SPAN = 15

export const GROUP_CHAT_SCOPES = {
  DELETED: 'deleted',
  SUPER_PRIVATE: 'superPrivate',
  PRIVATE: 'private',
  GLOBAL: 'global'
}

export const GROUP_CHAT_SCOPE_OPTIONS = [
  {val: GROUP_CHAT_SCOPES.SUPER_PRIVATE, label: 'Super Private'},
  {val: GROUP_CHAT_SCOPES.PRIVATE, label: 'Private'},
  {val: GROUP_CHAT_SCOPES.GLOBAL, label: 'Global'},
  {val: GROUP_CHAT_SCOPES.DELETED, label: 'Deleted'}
]

export const GROUP_CHAT_MODERATED_OPTIONS = [
  {val: false, label: 'No', isDefault: true},
  {val: true, label: 'Yes'}
]

export const GROUP_CHAT_SUBSCRIPTION_TYPES = {
  INSTANT: 'instant',
  DAILY: 'daily',
  WEEKLY: 'weekly'
}

export const SCROLL_POS_CONCERNS = {
  HISTORY: -1,
  TOP: 0,
  MIDDLE: 1,
  BOTTOM: 2,
  FORCE_BOTTOM: 3
}

export const CONVERSATION_PANE_STATUSES = {
  OPEN: 1,
  MINIMIZED: 2
}

export const CHAT_LIST_WIDTH = 300
export const CHAT_LIST_RIGHT_MARGIN = 20
export const CONVERSATION_PANE_WIDTH = 300
export const CONVERSATION_PANE_HEIGHT = 400

export const CONVERSATION_PANE_ADV_DIMENSIONS = {
  WIDTH: 280,
  HEIGHT: 44
}

export const CHAT_BOT_ADVERTISEMENT_SIZES = [
  {val: 250, label: 'Square Unit (300x250)'},
  {val: 50, label: 'Rectangle Unit (320x50)'}
]

export const SEARCH_TRANSACTION_TYPES = {
  CREATE: 'create',
  DELETE: 'delete',
  RECREATE: 'recreate',
  INDEX: 'index',
  SEARCH: 'search'
}


/** WEBPACK FOOTER **
 ** ./modules/shared/config/constants.js
 **/